import 'src/i18n/config';

import React, { useEffect, useState } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { RouterProvider } from 'react-router-dom';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import dayjs from 'dayjs';

import { MotionLazyContainer } from './components/animate';
import { setRootStoreSingleton } from './models/root-store/root-store-singleton';
import { RootStore, RootStoreProvider, setupRootStore } from './models';
import router from './routes';
import ThemeProvider from './theme';

function App() {
  const [rootStore, setRootStore] = useState<RootStore | undefined>(undefined);
  const { i18n } = useTranslation();

  useEffect(() => {
    // setup root store
    setupRootStore().then((store) => {
      setRootStore(store);
      setRootStoreSingleton(store);
      store.authStore.getUserProfile();
    });
  }, []);

  // 언어 변경 시 locale 변경
  useEffect(() => {
    dayjs.locale(i18n.language);
  }, [i18n.language]);

  if (!rootStore) {
    return null;
  }

  return (
    <RootStoreProvider value={rootStore}>
      <HelmetProvider>
        <ThemeProvider>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <MotionLazyContainer>
              <RouterProvider
                router={router}
                future={{
                  v7_startTransition: true,
                }}
              />
            </MotionLazyContainer>
          </LocalizationProvider>
        </ThemeProvider>
      </HelmetProvider>
    </RootStoreProvider>
  );
}

export default App;
